// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"624":"999761af","839":"7aa15517"}[chunkId] + ".chunk.js";
};